import React from "react";
import LandingLayout from "../landing/LandingLayout";
import { AboutPage } from "../landing/AboutPage";

export default function About() {
  return (
    <LandingLayout>
      <AboutPage />
    </LandingLayout>
  );
}
